import { Stack, Typography, useMediaQuery } from "@mui/material";
import schoolEmblemConstants from "../../data/about/schoolEmblem.json";
import { baseurl } from "../../config";

type Props = {};

const SchoolEmblem = (props: Props) => {
  const isSmallScreen = useMediaQuery("(max-width:650px)");
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
        {schoolEmblemConstants?.title}
      </Typography>
      <img
        src={`${baseurl}${schoolEmblemConstants?.emblem}`}
        alt={`${schoolEmblemConstants?.title}`}
        width="150px"
        style={{ margin: isSmallScreen ? "1rem auto" : "1.5rem auto" }}
      />
      <Stack direction="column" spacing={2}>
        {schoolEmblemConstants?.description?.map(
          (desc: string, index: number) => (
            <Typography
              variant="body2"
              sx={{ fontFamily: "inherit" }}
              textAlign="justify"
              key={index}
            >
              {desc}
            </Typography>
          )
        )}
      </Stack>
    </Stack>
  );
};

export default SchoolEmblem;
